import {
  faChevronLeft,
  faClockRotateLeft,
  faComment,
  faSidebarFlip,
} from '@fortawesome/pro-regular-svg-icons';
import type { IconDefinition } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Body,
  Button,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';
import { useChatStore } from '../hooks/useChatStore';

export function ChatHeader() {
  const { t } = useTranslation();
  const close = useChatStore((state) => state.close);
  const reset = useChatStore((state) => state.reset);
  const isHistoryOpen = useChatStore((state) => state.isHistoryOpen);
  const openHistory = useChatStore((state) => state.openHistory);
  const closeHistory = useChatStore((state) => state.closeHistory);

  const startNewChat = () => {
    reset();
    closeHistory();
  };

  return (
    <header className="flex items-center justify-between">
      {isHistoryOpen ? (
        <Button
          variant="ghost"
          size="small"
          onClick={closeHistory}
          aria-label={t('domain.ai.chat.history.back')}
          className="-ml-2 gap-1 rounded-md px-2">
          <FontAwesomeIcon icon={faChevronLeft} className="size-3.5" />
          <span className="font-semibold">
            {t('domain.ai.chat.history.title')}
          </span>
        </Button>
      ) : (
        <Body size="sm" weight="semibold">
          {t('domain.ai.chat.title')}
        </Body>
      )}
      <div className="flex items-center gap-0.5">
        <HeaderButton
          icon={faComment}
          label={t('domain.ai.chat.newChat')}
          onClick={startNewChat}
        />
        <HeaderButton
          icon={faClockRotateLeft}
          label={t('domain.ai.chat.history.title')}
          onClick={isHistoryOpen ? closeHistory : openHistory}
          active={isHistoryOpen}
        />
        <HeaderButton
          icon={faSidebarFlip}
          label={t('domain.ai.chat.close')}
          onClick={close}
        />
      </div>
    </header>
  );
}

function HeaderButton({
  icon,
  label,
  onClick,
  active,
}: {
  icon: IconDefinition;
  label: string;
  onClick: () => void;
  active?: boolean;
}) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="small"
          iconOnly
          aria-label={label}
          aria-pressed={active}
          onClick={onClick}
          className={active ? 'rounded-md bg-neutrals-v2-200' : 'rounded-md'}>
          <FontAwesomeIcon icon={icon} className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
